import { CatsRecordTypeEnum } from '@shared-enums/cats.enum';

import { ITableConfigEntity } from '../interfaces/internal-interfaces';
import { CatsRecord } from '../scripts/catsRecord';
import { ProductionText } from './ProductionText';

export class ProductionTextRecord extends CatsRecord {
  constructor(
    public readonly parent: ProductionText,
    config: ITableConfigEntity[],
  ) {
    super('ptx');
    this.__config = config;
  }

  public getRequiredObject(productionText: ProductionText): this {
    this.Employeenumber = productionText.getPlaceholderEmployee();
    this.Workdate = productionText.focusedDay?.unix ?? null;
    this.Quantity = 1;
    this.ZempCreatedBy = productionText.getPlaceholderEmployee();
    this.Statkeyfig = productionText.SKF;
    this.Zmatnr = 'NC';
    this.Longtext = true;
    this.LongTextstr = '';
    this.Zrecordtype = CatsRecordTypeEnum.ProductionText;
    return this;
  }
}
